export default "__VITE_ASSET__DgMZYOaB__"